module.exports = __webpack_public_path__ + "static/og-image-2-332027d7243af7a7bfae3f0a1bac46a7.jpg";